(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('download-agreements', {
                parent: 'app',
                url: '/download-agreements',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                    pageTitle: 'global.menu.entities.downloadAgreement'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/download-agreements/download-agreements.html',
                        controller: 'DownloadAgreementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agreements');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                },
            });
    }
})();
